/**
    客户服务 文章
**/
<template>
  <div style="width: 1200px; margin: auto">
    <!-- 面包屑导航 -->
    <el-breadcrumb
      class="breakcrumbHeader"
      separator-class="el-icon-arrow-right"
    >
      <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>文章</el-breadcrumb-item>
    </el-breadcrumb>
    <el-row style="margin-left: 0px;" :gutter="60">
      <el-col :span="6">
          <div  class="leftaside">
              <p class="articleText">文章分类</p>
                <el-menu
                        router
                        :default-active="defaultActive"
                        :default-openeds="defalut"
                        :unique-opened='true'
                        background-color="#f7f8f8"
                        active-text-color='#ff6700'
                        class="el-menu-vertical-demo">
                            <!-- <el-submenu index="0" v-for="item in leftMenu" :key="item.id">
                                <template slot="title">{{item.menu}}</template>
                                <el-menu-item-group>
                                    <el-menu-item v-for="subMenu in item.sub_menu" :key="subMenu.id" :index="subMenu.url">
                                            <template slot="title">{{subMenu.title}}</template>
                                        <el-submenu>
                                            <el-menu-item-group v-if="subMenu.sub_menu?true:false">
                                                <el-menu-item v-for="item3 in subMenu.sub_menu" :key="item3.id" :index="subMenu.url">{{item3.title}}</el-menu-item>
                                            </el-menu-item-group>
                                        </el-submenu>
                                        
                                        </el-menu-item>
                                </el-menu-item-group>
                            </el-submenu> -->

                            <el-submenu :index="defaultActive" v-for="item in leftMenu" :key="item.id">
                                <template slot="title">{{item.title}}</template>
                                <el-menu-item-group>
                                    <el-menu-item v-for="subMenu in item.sub_menu" :key="subMenu.id" :index="subMenu.url+`&categoryId=${subMenu.id}`">{{subMenu.title}}</el-menu-item>
                                </el-menu-item-group>
                            </el-submenu>

                        </el-menu>
          </div>
          <div>
               <hotArticle :articleList='articleList' :navTitle='navTitle'></hotArticle>
          </div>
      </el-col>
      <!-- <el-col :span="24">
         
      </el-col> -->
      <el-col :span="17" class="rightaside">
          <router-view></router-view>
      </el-col>
    </el-row>
    <!-- <div>
        
    </div> -->
  </div>
</template>
<script>
import {article_category_list,helpArticle_list} from '@/api/xunyou'
import hotArticle from '@/components/hotArticle'
export default {
  data() {
    return {
        articleList:[],
        navTitle:'热门文章',
        isShowHot:false,
        defalut:[this.$route.fullPath],
        defaultActive:this.$route.fullPath,
        leftMenu:[
            // {
            //     id:1,
            //     menu:'站点帮助',
            //     url:'/siteHelp?articleId=1',
            //     sub_menu:[
            //         {
            //             id:1,
            //             title:'帮助中心',
            //             url:'/siteHelp?articleId=2',
            //         },
            //         {
            //             id:2,
            //             title:'店主之家',
            //             url:'/siteHelp?articleId=3',
            //         },
            //         {
            //             id:3,
            //             title:'支付方式',
            //             url:'/siteHelp?articleId=4',
            //         },
            //         {
            //             id:4,
            //             title:'售后服务',
            //             url:'/siteHelp?articleId=5',
            //         },
            //         {
            //             id:5,
            //             title:'客服中心',
            //             url:'/siteHelp?articleId=6',
            //         },{
            //             id:6,
            //             title:'关于我们',
            //             url:'/siteHelp?articleId=7',
            //         },{
            //             id:7,
            //             title:'商家入驻',
            //             url:'/siteHelp?articleId=8',
            //             sub_menu:[
            //                 {
            //                     id:1,
            //                     title:'入驻流程',
            //                     url:'/siteHelp?articleId=9',
            //                 }
            //             ]
            //         },
            //     ]
            // },
        ], 
    };
  },
  // 注册组件
  components: {hotArticle},
  /**
   * 数据发生改变
   */

//   watch:{

//     $route(n,o){
//         if(n.fullPath.indexOf('itemId')>0){ //监听路由参数是否变化
//         console.log(n.fullPath,'路径上水水水水')
//         this.isShowHot = !this.isShowHot
//         }
//     }

// },

  /**
   * 创建完毕
   */
  created() {
      console.log(this);
  },
  mounted(){
      if(this.$route.fullPath.indexOf('categoryId')>0){
          this.defaultActive = this.$route.fullPath
          this.defalut[0] = this.$route.fullPath
      };
    //   if(this.$route.fullPath.indexOf('itemId')>0){
    //       this.isShowHot = !this.isShowHot
    //   };
      this.getArticleList()
      this.getHelpArticle_list()
    //   console.log(this.$route,this.$route.fullPath,'路劲发')
  },

   watch: {
    '$route' (to, from) { //监听路由是否变化
      if(to.query.categoryId != from.query.categoryId){//判断categoryId是否有值
        //调数据
        if(this.$route.fullPath.indexOf('categoryId')>0){
            this.defaultActive = this.$route.fullPath
            this.defalut[0] = this.$route.fullPath
        };
      }
    }
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
        // 文章分类列表   
        getArticleList(){
            article_category_list()
                .then(res => {
                if (res.code == 0) {
                    console.log(res)
                    this.leftMenu = res.data;
                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                this.editFormVisible = false
                this.loading = false
                this.$message.error('获取文章分类列表失败，请稍后再试！')
                })
        },
           // 文章（和公告）列表接口   
        getHelpArticle_list(){
            helpArticle_list({
                articleIsPopular:1  // 热门文章查询
            })
                .then(res => {
                    console.log(res)
                if (res.code == 0) {
                    this.articleList = res.rows.slice(0,5);
                } else {
                    this.$message({
                    type: 'info',
                    message: res.msg
                    })
                }
                })
                .catch(err => {
                // this.loading = false
                this.$message.error('获取文章列表失败，请稍后再试！')
                })
        },
    },
};
</script>

<style scoped lang="less">
.breakcrumbHeader {
  margin: 15px 0;
}
.leftaside {
    // background: white;
    // padding: 30px;
    box-sizing: border-box;
    border: 1px solid #ccc;
    padding: 0 !important;
    margin-bottom: 20px;
    p.articleText {
        font-size: 15px;
        font-weight: 800;
        padding: 10px 20px;
        border-bottom: 1px solid #ccc;
    }
    .el-menu{
        border-right:0px;
        background: transparent;
        /deep/ul.el-menu.el-menu--inline {
            background-color: transparent !important;
        }
        .el-submenu__title{
            font-size: 15px;
            height: 40px;
            line-height: 40px;
        }
        li.el-menu-item-group {
            margin-bottom: 15px;
        }
    }
    /deep/ .el-menu-item-group__title {
            padding: 0px;
            line-height: normal;
            font-size: 14px;
            color: #333;
        }
    li.el-menu-item {
        height: 24px;
        line-height: 24px;
        font-size: 12px;        
    }
    .el-menu-item:focus, .el-menu-item:hover {
        outline: 0;
        background-color: transparent;
    }
    .el-menu-item.is-active {
        color: #ff6700;
    }
}


</style>

 
 

 


// WEBPACK FOOTER //
// src/views/serviceArticle/index.vue